// Home.js
import React from "react";
import "../../App.css";
import HeroTextPart from "./HeroTextPart";
import "bootstrap/dist/css/bootstrap.min.css";
import Statistics from "../Extras/statistics";
import ParticleBg from "./ParticleBg";
import AboutInfo from "./AboutInfo";
import Contacts from "../Extras/Contacts";

import SponsorsSlider from "../Sponsorships/SponsorsSlider";
import { Parallax } from "react-parallax";
import IMAGES from "../../images/images.js";
import CustomButton from "../Extras/CustomButton";
import ProjectBigCard from "./ProjectBigCard";
import CustomButtonDown from "../Extras/CustomButtonDown";

const Home = () => {
  return (
    <div className="page-wrapper">
      {/* Hero-section */}
      <Parallax
        bgImage={IMAGES.mainTrans}
        bgImageStyle={{
          width: "100vw",
          maxWidth: "100%",
          objectFit: "cover",
          height: "100vh"
        }}
        style={{ width: "100%", overflow: "hidden" }}
        strength={150}
      >
        <div className="Main-hero-part">
          <div className="main-hero-text-part">
            <HeroTextPart />
          </div>
          <ParticleBg />
        </div>
      </Parallax>
      {/* End hero-section */}

      {/* About us section */}
      <div className="about-us">
        <Statistics />
        <AboutInfo />
      </div>
      {/* End About Us section */}

      {/* Projects section */}
      <div className="projects">
        <div className="projects-container">
          <div className="project-main-title">
            <h1>OUR PROJECTS</h1>
          </div>
          <div className="cards">
            <ProjectBigCard
              bgImg={IMAGES.marsChamber}
              title="Mars Chamber"
              link="Chamber"
              desc="The Martian Atmospheric Simulation Chamber (MASC) project aims to build a simulation chamber where products can be tested in a low temperature and pressure environment."
            />
            <ProjectBigCard
              bgImg={IMAGES.sabatierImg}
              title="Sabatier Fuel Plant"
              link="sabatier"
              desc="The Sabatier Fuel Plant Project aims to propose plans for a full-scale propellant manufacturing plant based on SpaceX's Mars mission architecture."
            />
          </div>
        </div>
      </div>
      {/* End projects section */}

      {/* Sponsors section */}
      <div className="my-5 w-100 overflow-hidden">
        <div className="sponsors-part px-3 text-center">
          <h1 
            style={{ 
              fontSize: "clamp(1.75rem, 5vw, 3.5rem)", 
              lineHeight: 1.2,
              wordBreak: "break-word"
            }}
          >
            OUR SUPPORTERS
          </h1>
          <p className="mx-auto" style={{ maxWidth: "800px" }}>
            Thank you! We rely heavily on the support of industry and community
            partners like all those listed on this page. Their generosity has
            allowed us to achieve more than any of us thought possible.
          </p>
          <div className="buttons">
            <CustomButtonDown
              target_link="/sponsors"
              text={"Learn More"}
              color={"startingred"}
            />
            <CustomButton
              target="_blank"
              target_link="https://donate.give.ubc.ca/page/80953/donate/1?transaction.dirgift=UBC+Mars+Colony%20G2316"
              text={"Sponsor Us"}
              color={"red"}
            />
          </div>
        </div>

        <div className="slider-box w-100 overflow-hidden">
          <SponsorsSlider />
        </div>
      </div>
      {/* End sponsors section */}

      {/* Contacts footer */}
      <div className="contact-us">
        <Contacts bgcolor={"red-footer"} />
      </div>

      <div
        className="text-center p-3 text-white"
        style={{ backgroundColor: "black" }}
      >
        © 2025 Copyright: UBCmarscolony.com
      </div>
      {/* End contacts section */}
    </div>
  );
};

export default Home;